import { Button } from "@components/core";
import { useTranslations } from "next-intl";
import { useCallback } from "react";

function LowResultsDeleteFilters({
  getInitializedUiState,
  resetPersonalisedFilters,
  setUiState,
  products,
}) {
  const t = useTranslations("catalog");

  const clearFiltersAndClose = useCallback(() => {
    const resetedUiState = getInitializedUiState({});
    setUiState(resetedUiState);

    resetPersonalisedFilters();
  }, [getInitializedUiState, resetPersonalisedFilters, setUiState]);

  if (!products?.length) return null;

  return (
    <div className="container d-flex flex-column align-items-center justify-content-center border-top border-bottom border-light mb-4 px-3 py-4 text-gray text-center">
      <p className="my-2 font-weight-bold">
        {t("low_results_section.have_not_found_what_you_are_looking_for")}
      </p>
      <p className="mb-0">{t("low_results_section.dont_worry")}</p>
      <Button
        trackingName="lowResultsCleanFilters"
        variant="link-primary"
        className="my-2 no-underline"
        onClick={clearFiltersAndClose}
      >
        {t("low_results_section.clear_filters")}
      </Button>
    </div>
  );
}

export default LowResultsDeleteFilters;
